import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/service/api.service';
import { CoreService } from 'src/app/service/core.service';

@Component({
  selector: 'app-sales-pos-res',
  templateUrl: './sales-pos-res.component.html',
  styleUrls: ['./sales-pos-res.component.css']
})
export class SalesPosResComponent implements OnInit {
  @ViewChild('selectInput', { static: false }) selectInput: ElementRef;

  payPageClick: boolean = false;
  editBtns: boolean = false;
  prod_alias: any;
  base_url: string;
  gd_id: string | Blob;
  productDetails: any;
  eInvoiceSupport: any;
  customer: any;
  // saleqt_date = <any>new Date();
  isLoader: boolean = false;

  selectedProduct = <any>[
    // {
    //   salesub_prd: <any>"",
    //   salesub_qty: null,
    //   prd_code: null,
    //   base_qty: null,
    //   salesub_rate: null,
    //   salesub_unit_id: "",
    //   salesub_tax_per: null,
    //   prd_tax_cat_id: null,
    //   salesub_tax: "",
    //   item_desc: "",
    //   salesub_gd_id: "",
    //   prod_units: [],
    //   unit: "",
    //   // qty: null,
    //   loadingImg: false,
    //   isSecondOptionDisabled: true,
    //   rate2_dsply_qty: 0,
    //   rate: null,
    //   disc_amnt: 0,
    //   item_disc_type: 2,
    //   excl_vat: 1,
    //   taxpercentage: null,
    //   itemRate: null,
    //   grnd_totl: null,
    //   base_unit_rate: null,
    //   item_disc: 0,
    //   item_bill_disc: 0,
    //   barcode: <any>"",
    //   stock_qty: 0,
    //   salesub_tax_amnt: 0,
    //   sel_rate_type: 1,
    // },
  ];
  savedSale = <any>[]
  country_dec: number;
  saleqt_time: any;
  user_name: any;
  edit_note: any;
  editIndex: any;
  custype: any;
  cust_vat: any;
  cust_mob: any;
  cust_addres: any;
  totItemprice = <any>0;
  totVatAmnt = <any>0;
  sale_total_amount = <any>0;
  totItemqty = <any>0;
  saleRefNo: any;
  qt_no: any;
  cashLedgers: any;
  bankLedgers: any;
  sale_pay_type: any;
  catagories: string[];
  favorites = [];
  favSelect: any;
  saleqt_date: Date;
  holdData = []
  bank_amnt: any;
  settings: any;
  vat_type: any;

  orderTypes = [
    { label: 'TAKE AWAY', icon: 'shopping_bag' },
    { label: 'DELIVERY', icon: 'local_shipping' },
    { label: 'DINE IN', icon: 'dining' },
    { label: 'FAMILY', icon: 'flatware' },
    { label: 'PREMIUM', icon: 'star' }
  ];

  selectedOrderType = 'TAKE AWAY';
  qt_number: any;
  holdTitle: any;
  recalldata: any = false;
  items: any;
  cash_amnt: any;
  balAmnt: any;
  recvdAmnt: any;
  cust_id: any;
  cash_cust: any = 'Cash Customer';
  showDisc: boolean;
  netDiscttl = 0;
  net_disc: any = 0;
  includeTax: any = 1;
  round_off: any = 0;
  roundOffValue: boolean;
  netDiscValue: boolean;
  cashAmntValue: boolean;
  bankAmntValue: boolean;
  balanceAmntValue: boolean;
  roundOffClick: any = 2;

  constructor(private translate: TranslateService, private apiService: ApiService, private coreService: CoreService, private modalService: NgbModal, public router: Router, private ActiveRoute: ActivatedRoute, private datePipe: DatePipe) { }

  ngOnInit() {
    this.getSalesSetting();
    this.base_url = this.apiService.PHP_API_SERVER;
    this.searchStkPrd('');
    this.searchCustomer('');
    this.country_dec = this.coreService.setDecimalLength();
    // this.saleqt_time = this.saleqt_date.toLocaleTimeString();
    this.updateTime();
    setInterval(() => this.updateTime(), 1000);
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      // this.langChange();
    });
    this.user_name = this.coreService.getUserData('usr_name');
    this.nextRefNo();
    this.searchBankLedger('');
    this.searchCashLedger('');
    this.searchCat('');

    this.apiService.getAllFavorites(1, 1000).subscribe((resp) => {
      this.favorites = resp.data;
    });
    this.showDisc = false;
  }

  getSalesSetting() {
    this.apiService.getSalesSetting().subscribe((res) => {

      if (res['data']) {
        this.settings = res['data'];
        this.vat_type = this.settings.vat_type;

      }
    });
  }

  updateTime() {
    this.saleqt_date = new Date();
    this.saleqt_time = this.saleqt_date.toLocaleTimeString();
  }

  // do not use this api other than sales bcz add some exeption in this (by ajmal)
  searchStkPrd(search: string) {
    let searchval = new FormData();
    searchval.append("keyword", search);
    searchval.append("stk_stat", "1");
    searchval.append("godown_id", this.gd_id);
    if (this.prod_alias) {
      searchval.append('alias_search', '1');
    }

    this.apiService.getSalesStockbyItem(searchval).subscribe((res) => {
      this.productDetails = res["data"];

      this.countUpdate();
      this.isLoader = false;
    });
  }

  searchCustomer(search: string) {
    const searchval = new FormData();
    searchval.append("cust_name", search);
    if (this.eInvoiceSupport) {
      searchval.append('einvoice_details', '1');
    }
    this.apiService.searchCustomer(searchval).subscribe((res) => {
      this.customer = res["data"];

    });
  }

  searchCat(search: string) {
    const searchval = new FormData();
    searchval.append('cat_name', search);
    this.apiService.getCatbyName(searchval).subscribe((res) => {
      this.catagories = res['data'];

    });

  }

  selectCat(cat_id) {

    this.isLoader = true;

    setTimeout(() => {
      let searchval = new FormData();
      searchval.append("keyword", '');
      searchval.append("stk_stat", "1");
      searchval.append("godown_id", this.gd_id);
      searchval.append("category_id", cat_id);
      if (this.prod_alias) {
        searchval.append('alias_search', '1');
      }

      this.apiService.getSalesStockbyItem(searchval).subscribe((res) => {
        this.productDetails = res["data"];
        // this.countUpdate();
        this.isLoader = false;
      });
    }, 500);
  }

  selectCustomer(cust_id) {
    if (cust_id) {
      this.cust_vat = cust_id.vat_no;
      this.cust_mob = cust_id.mobile;
      this.cust_addres = cust_id.cust_home_addr;
    } else {
      this.cust_vat = '';
      this.cust_mob = '';
      this.cust_addres = '';
    }

  }

  searchStkPrdBarcode(search: any) {
    this.isLoader = true;
    if (!search) {
      this.searchStkPrd('');
    }

    if (search) {
      setTimeout(() => {
        let searchval = new FormData();
        searchval.append("barcode", search);
        this.apiService.getStockbyBarcodeSales(searchval).subscribe((res) => {
          if (res.data) {
            this.productDetails = Array.isArray(res.data) ? res.data : [res.data];
            this.countUpdate();
            this.isLoader = false;
          }

        });
      }, 500);
    }
  }

  nextRefNo() {
    let searchval = new FormData();

    this.apiService.getSaleRefNo(searchval).subscribe((res) => {
      this.saleRefNo = res['data'].sale_num;
      this.qt_no = res['data'].sq_branch_qt_no;
      this.qt_number = this.qt_no;
    });
  }


  selectProd(data) {

    console.log("data");
    console.log(data);
    
    let rate = data.bs_srate; 

    

    if ((this.selectedProduct.length > 0) && (this.selectedProduct.find(x => x.salesub_prd_id === data.prd_id))) {
      this.selectedProduct.find(x => x.salesub_prd_id === data.prd_id).salesub_qty++;
      this.selectedProduct.find(x => x.salesub_prd_id === data.prd_id).salesub_tax += ((rate / 100) * data.prd_tax);
      this.selectedProduct.find(x => x.salesub_prd_id === data.prd_id).salesub_tax_amnt = ((rate / 100) * data.prd_tax)*this.selectedProduct.find(x => x.salesub_prd_id === data.prd_id).salesub_qty;
      this.selectedProduct.find(x => x.salesub_prd_id === data.prd_id).sale_total_amount += rate * 1 + ((rate / 100) * data.prd_tax);
      this.selectedProduct.find(x => x.salesub_prd_id === data.prd_id).salesub_price = rate * this.selectedProduct.find(x => x.salesub_prd_id === data.prd_id).salesub_qty;

    } else {

      if (this.vat_type == 1) {
      let t = data.bs_srate - ((data.bs_srate * 100) / (data.prd_tax + 100));
      let p = data.bs_srate - t;
      rate = p;
      
    }
      this.selectedProduct.push({
        "salesub_prd": data.prd_name, "salesub_prd_id": data.prd_id, "salesub_rate": rate, "salesub_price": rate, "salesub_tax": ((rate / 100) * data.prd_tax), "salesub_tax_per": data.prd_tax, "salesub_qty": 1, "count": 1, "salesub_note": '', 'sale_total_amount': rate + ((rate / 100) * data.prd_tax),"salesub_tax_amnt":(((rate / 100) * data.prd_tax)*1)
      });
    }

    console.log("this.selectedProduct");
    console.log(this.selectedProduct);
    

    this.countUpdate();
    this.sumSaleTotal();
  }

  countUpdate() {
    this.selectedProduct.forEach((element, i) => {

      console.log("element");
      console.log(element);
      
      this.productDetails.find(x => x.prd_id === element.salesub_prd_id) ? this.productDetails.find(x => x.prd_id === element.salesub_prd_id).count = element.salesub_qty : '';

      this.productDetails.find(x => x.prd_id === element.salesub_prd_id) ? this.productDetails.find(x => x.prd_id === element.salesub_prd_id).salesub_tax = element.salesub_qty : '';

      element.salesub_tax_amnt = ((element.salesub_rate / 100) * element.salesub_tax_per) * element.salesub_qty;
      element.sale_total_amount = (element.salesub_rate + ((element.salesub_rate / 100) * element.salesub_tax_per)) * element.salesub_qty;
      
    });

    console.log("this.selectedProduct");
    console.log(this.selectedProduct);
    

    this.sumSaleTotal();
  }

  delete(index) {
    this.productDetails.find(x => x.prd_id === this.selectedProduct[index].salesub_prd_id).count = 0;
    this.selectedProduct.splice(index, 1);

    if (this.selectedProduct.length == 0) {
      this.net_disc = 0;
      this.netDiscttl = 0;
      this.round_off = 0;
    }

    this.countUpdate();
  }

  payPage() {
    this.payPageClick = true;
  }

  back() {
    this.payPageClick = false;
  }

  editItem(index) {
    this.editBtns = true;
    this.editIndex = index;
    this.edit_note = this.selectedProduct[index].salesub_note;

  }

  addnote(e: string) {
    this.selectedProduct[this.editIndex].salesub_note = e;
  }

  changeQty(value) {
    if (value) {
      this.selectedProduct[this.editIndex].salesub_qty++;
    } else {
      if (this.selectedProduct[this.editIndex].salesub_qty > 0) {
        this.selectedProduct[this.editIndex].salesub_qty--;
      }
    }
    this.countUpdate();
  }

  inputQty(value) {
    // edit product
    if (this.selectedProduct && this.editIndex >= 0 && !this.roundOffValue && !this.netDiscValue && !this.cashAmntValue && !this.bankAmntValue && !this.balanceAmntValue) {
      let exist_qty = this.selectedProduct[this.editIndex].salesub_qty > 0 ? this.selectedProduct[this.editIndex].salesub_qty : '';
      this.selectedProduct[this.editIndex].salesub_qty = exist_qty.toString() + value.toString();
      this.countUpdate();
    }

    // round off
    if (this.roundOffValue) {
      let existRound = this.round_off > 0 ? this.round_off : '';
      this.round_off = existRound.toString() + value.toString();
    }

    // discount / item discount
    if (this.netDiscValue) {
      let existDisc = this.net_disc > 0 ? this.net_disc : '';
      this.net_disc = existDisc.toString() + value.toString();
    }

    // Cash Amount
    if (this.cashAmntValue && this.sale_pay_type == 4) {
      let existCashAmnt = this.cash_amnt > 0 ? this.cash_amnt : '';
      this.cash_amnt = existCashAmnt.toString() + value.toString();
      this.bank_amnt = (this.roundOffClick == 1) ? Number(this.sale_total_amount - this.cash_amnt - this.netDiscttl + Number(this.round_off)).toFixed(2) : Number(this.sale_total_amount - this.cash_amnt - this.netDiscttl - Number(this.round_off)).toFixed(2);
    }

    // Bank Amount
    if (this.bankAmntValue && this.sale_pay_type == 4) {
      let existBankAmnt = this.bank_amnt > 0 ? this.bank_amnt : '';
      this.bank_amnt = existBankAmnt.toString() + value.toString();
      this.cash_amnt =(this.roundOffClick == 1) ? Number(this.sale_total_amount - this.bank_amnt - this.netDiscttl + Number(this.round_off)).toFixed(2) : Number(this.sale_total_amount - this.bank_amnt - this.netDiscttl - Number(this.round_off)).toFixed(2);
    }

    // Balance Amount
    if (this.balanceAmntValue) {
      let existBalanceAmnt = this.recvdAmnt > 0 ? this.recvdAmnt : '';
      this.recvdAmnt = existBalanceAmnt.toString() + value.toString();
      this.balAmnt = (this.roundOffClick == 1) ? Number(this.sale_total_amount - this.recvdAmnt - this.netDiscttl + Number(this.round_off)).toFixed(2) : Number(this.sale_total_amount - this.recvdAmnt - this.netDiscttl - Number(this.round_off)).toFixed(2);
    }
  }

  clearQty() {
    // edit product
    if (this.selectedProduct && this.editIndex >= 0 && !this.roundOffValue && !this.cashAmntValue && !this.bankAmntValue && !this.balanceAmntValue) {
      this.selectedProduct[this.editIndex].salesub_qty = 0;
      this.countUpdate();
    }

    // round off
    if (this.roundOffValue) {
      this.round_off = 0;
    }

    // discount / item discount
    if (this.netDiscValue) {
      this.net_disc = 0;
    }

    // Cash Amount
    if (this.cashAmntValue && this.sale_pay_type == 4) {
      this.cash_amnt = 0;
    }

    // Bank Amount
    if (this.bankAmntValue && this.sale_pay_type == 4) {
      this.bank_amnt = 0;
    }

    // Balance Amount
    if (this.balanceAmntValue) {
      this.recvdAmnt = 0;
    }
  }

  backspace() {
    // edit product
    if (this.selectedProduct && this.editIndex >= 0 && !this.roundOffValue && !this.cashAmntValue && !this.bankAmntValue && !this.balanceAmntValue) {
      let exist_qty = this.selectedProduct[this.editIndex].salesub_qty > 0 ? this.selectedProduct[this.editIndex].salesub_qty.toString() : '';

      if (exist_qty.length > 0) {
        this.selectedProduct[this.editIndex].salesub_qty = exist_qty.toString().slice(0, -1);
      }
      this.countUpdate();
    }

    // round off
    if (this.roundOffValue) {
      let existDisc = this.round_off > 0 ? this.round_off.toString() : '';

      if (existDisc.length > 0) {
        this.round_off = existDisc.toString().slice(0, -1);
      }
    }

    // discount / item discount
    if (this.netDiscValue) {
      let existRound = this.net_disc > 0 ? this.net_disc.toString() : '';

      if (existRound.length > 0) {
        this.net_disc = existRound.toString().slice(0, -1);
      }
    }

    // Cash Amount
    if (this.cashAmntValue && this.sale_pay_type == 4) {
      let existCashAmnt = this.cash_amnt > 0 ? this.cash_amnt.toString() : '';

      if (existCashAmnt.length > 0) {
        this.cash_amnt = existCashAmnt.toString().slice(0, -1);
        this.bank_amnt = (this.roundOffClick == 1) ? Number(this.sale_total_amount - this.cash_amnt - this.netDiscttl + Number(this.round_off)).toFixed(2) : Number(this.sale_total_amount - this.cash_amnt - this.netDiscttl - Number(this.round_off)).toFixed(2);
      }
    }

    // Bank Amount
    if (this.bankAmntValue && this.sale_pay_type == 4) {
      let existBankAmnt = this.bank_amnt > 0 ? this.bank_amnt.toString() : '';

      if (existBankAmnt.length > 0) {
        this.bank_amnt = existBankAmnt.toString().slice(0, -1);
        this.cash_amnt = (this.roundOffClick == 1) ? Number(this.sale_total_amount - this.bank_amnt - this.netDiscttl + Number(this.round_off)).toFixed(2) : Number(this.sale_total_amount - this.bank_amnt - this.netDiscttl - Number(this.round_off)).toFixed(2);
      }
    }

    // Balance Amount
    if (this.balanceAmntValue) {
      let existBalanceAmnt = this.recvdAmnt > 0 ? this.recvdAmnt.toString() : '';

      if (existBalanceAmnt.length > 0) {
        this.recvdAmnt = existBalanceAmnt.toString().slice(0, -1);
        this.balAmnt = (this.roundOffClick == 1) ? Number(this.sale_total_amount - this.recvdAmnt - this.netDiscttl + Number(this.round_off)).toFixed(2) : Number(this.sale_total_amount - this.recvdAmnt - this.netDiscttl - Number(this.round_off)).toFixed(2);
      }
    }

  }

  decimalQty() {
    // edit product
    if (this.selectedProduct && this.editIndex >= 0 && !this.roundOffValue && !this.cashAmntValue && !this.bankAmntValue && !this.balanceAmntValue) {
      let exist_qty = this.selectedProduct[this.editIndex].salesub_qty > 0 ? this.selectedProduct[this.editIndex].salesub_qty.toString() : '';
      this.selectedProduct[this.editIndex].salesub_qty = exist_qty += '.';
    }

    // round off
    if (this.roundOffValue) {
      let existRound = this.round_off > 0 ? this.round_off.toString() : '';
      this.round_off = existRound += '.';
    }

    // discount / item discount
    if (this.netDiscValue) {
      let existDisc = this.net_disc > 0 ? this.net_disc.toString() : '';
      this.net_disc = existDisc += '.';
    }

    // Cash Amount
    if (this.cashAmntValue && this.sale_pay_type == 4) {
      let existCashAmnt = this.cash_amnt > 0 ? this.cash_amnt.toString() : '';
      this.cash_amnt = existCashAmnt += '.';
      this.bank_amnt = (this.roundOffClick == 1) ? Number(this.sale_total_amount - this.cash_amnt - this.netDiscttl + Number(this.round_off)).toFixed(2) : Number(this.sale_total_amount - this.cash_amnt - this.netDiscttl - Number(this.round_off)).toFixed(2);
    }

    // Bank Amount
    if (this.bankAmntValue && this.sale_pay_type == 4) {
      let existBankAmnt = this.bank_amnt > 0 ? this.bank_amnt.toString() : '';
      this.bank_amnt = existBankAmnt += '.';
      this.cash_amnt = (this.roundOffClick == 1) ? Number(this.sale_total_amount - this.bank_amnt - this.netDiscttl + Number(this.round_off)).toFixed(2) : Number(this.sale_total_amount - this.bank_amnt - this.netDiscttl - Number(this.round_off)).toFixed(2);
    }

    // Bank Amount
    if (this.balanceAmntValue) {
      let existBalanceAmnt = this.recvdAmnt > 0 ? this.recvdAmnt.toString() : '';
      this.recvdAmnt = existBalanceAmnt += '.';
      this.balAmnt = (this.roundOffClick == 1) ? Number(this.sale_total_amount - this.recvdAmnt - this.netDiscttl + Number(this.round_off)).toFixed(2) : Number(this.sale_total_amount - this.recvdAmnt - this.netDiscttl - Number(this.round_off)).toFixed(2);
    }

  }

  resetBtn() {
    this.selectedProduct.forEach((element, i) => {
      this.productDetails.find(x => x.prd_id === element.salesub_prd_id).count = 0;
    });
    this.selectedProduct = [];
    this.net_disc = 0;
    this.netDiscttl = 0;
    this.round_off = 0;
    this.sumSaleTotal();
  }

  changeSubQty() {
    this.countUpdate();

  }

  changecustype() {
    if (!this.custype) {
      this.cust_vat = '';
      this.cust_mob = '';
      this.cust_addres = '';
    }

  }

  sumSaleTotal() {
    this.totItemprice = 0;
    this.totItemqty = 0;
    // this.totItempriceWithoutBillDisc = 0;
    // this.totItemDisc = 0;
    // this.totItemDiscWithoutBillDisc = 0;
    this.totVatAmnt = 0;
    this.sale_total_amount = 0;
    // this.totVatAmntWithoutBillDisc = 0;
    // this.billDiscountTtl = 0;

    console.log("this.selectedProduct");
    console.log(this.selectedProduct);
    

    for (var i = 0; i < this.selectedProduct.length; i++) {

      this.totItemqty =
        Number(this.totItemqty) +
        Number(this.selectedProduct[i]["salesub_qty"]);
      this.totItemprice =
        Number(this.totItemprice) +
        Number(this.selectedProduct[i]["salesub_qty"]) *
        Number(this.selectedProduct[i]["salesub_rate"]);
      // this.totItempriceWithoutBillDisc =
      //   Number(this.totItempriceWithoutBillDisc) +
      //   Number(this.selectedProduct[i]["salesub_qty"]) *
      //     Number(this.selectedProduct[i]["salesub_rate_without_bill_disc"]);
      // this.totItemDisc =
      //   Number(this.totItemDisc) + Number(this.selectedProduct[i]["item_disc"]);
      // this.totItemDiscWithoutBillDisc =
      //   Number(this.totItemDiscWithoutBillDisc) +
      //   Number(this.selectedProduct[i]["item_disc_WithoutBillDisc"]);
      this.totVatAmnt =
        Number(this.totVatAmnt) +
        Number(this.selectedProduct[i]["salesub_tax_amnt"]);
      // this.totVatAmntWithoutBillDisc =
      //   Number(this.totVatAmntWithoutBillDisc) +
      //   Number(this.salesItems[i]["salesub_tax_amnt_WithoutBillDisc"]);

      this.sale_total_amount = Number(this.sale_total_amount) + Number(this.selectedProduct[i]["sale_total_amount"]);
      
    }
    // if(this.sale_pay_type==4){
    //   this.changePay(4);
    // }
    this.payType(2);
    // this.roundOffTypeClick(2);
    this.balAmnt = 0;
    this.recvdAmnt = (this.roundOffClick == 1) ? Number(this.sale_total_amount - this.netDiscttl + Number(this.round_off)).toFixed(2) : Number(this.sale_total_amount - this.netDiscttl - Number(this.round_off)).toFixed(2);
  }

  updateItemDiscount() {
    this.netDiscttl = (this.includeTax == 2) ? 0 : this.net_disc;
    let gttl = 0;
    this.selectedProduct.forEach((element, i) => {
      gttl += Number(this.selectedProduct[i].salesub_rate * this.selectedProduct[i].salesub_qty);
    });

    let InpbillDisc = this.net_disc || 0;

    this.selectedProduct.forEach((element, i) => {
      // include tax
      if (this.includeTax == 2) {
        if (this.net_disc > 0) {
          let grnd_totl = this.selectedProduct[i].salesub_rate;
          let billDiscPrec = grnd_totl * this.selectedProduct[i].salesub_qty * 100 / gttl;
          let billDiscountAmt = (InpbillDisc / 100 * billDiscPrec);

          if (billDiscountAmt >= 0) {
            this.selectedProduct[i].item_disc = billDiscountAmt;
            let tax = 0;

            if (this.vat_type == 0) {
              console.log("inc vat type1");

              tax = ((this.selectedProduct[i].salesub_price - (this.selectedProduct[i].item_disc)) * this.selectedProduct[i].salesub_tax_per) / 100;

              this.selectedProduct[i].salesub_tax = tax / this.selectedProduct[i].salesub_qty;
              this.selectedProduct[i].salesub_tax_amnt = tax;
              this.selectedProduct[i].salesub_rate = this.selectedProduct[i].salesub_price / this.selectedProduct[i].salesub_qty;
              this.selectedProduct[i].sale_total_amount = this.selectedProduct[i].salesub_rate * this.selectedProduct[i].salesub_qty + this.selectedProduct[i].salesub_tax_amnt - this.selectedProduct[i].item_disc;
              this.selectedProduct[i].salesub_amnt = this.selectedProduct[i].salesub_rate * this.selectedProduct[i].salesub_qty;
            } else {
              console.log("inc vat type2");

              tax = (this.selectedProduct[i].salesub_price - (this.selectedProduct[i].item_disc)) - (((this.selectedProduct[i].salesub_price - (this.selectedProduct[i].item_disc)) * 100) / (this.selectedProduct[i].salesub_tax_per + 100));

              this.selectedProduct[i].salesub_tax = tax / this.selectedProduct[i].salesub_qty;
              this.selectedProduct[i].salesub_tax_amnt = tax;
              this.selectedProduct[i].salesub_rate = (this.selectedProduct[i].salesub_price - tax) / this.selectedProduct[i].salesub_qty;
              this.selectedProduct[i].sale_total_amount = this.selectedProduct[i].salesub_rate * this.selectedProduct[i].salesub_qty + this.selectedProduct[i].salesub_tax_amnt - this.selectedProduct[i].item_disc;
              // this.selectedProduct[i].salesub_rate = (this.selectedProduct[i].salesub_price - tax + Number(this.selectedProduct[i].promo_disc)) / this.selectedProduct[i].salesub_qty;
              this.selectedProduct[i].salesub_amnt = this.selectedProduct[i].salesub_rate * this.selectedProduct[i].salesub_qty;
            }
          }

        }

      } else {
        // exclude tax
        if (this.netDiscttl > 0) {
          this.selectedProduct[i].item_disc = 0;
          let tax = 0;

          if (this.vat_type == 0) {
            console.log("exc vat type1");
            tax = ((this.selectedProduct[i].salesub_price - (this.selectedProduct[i].item_disc)) * this.selectedProduct[i].salesub_tax_per) / 100;

            this.selectedProduct[i].salesub_tax = tax / this.selectedProduct[i].salesub_qty;
            this.selectedProduct[i].salesub_tax_amnt = tax;
            this.selectedProduct[i].salesub_rate = this.selectedProduct[i].salesub_price / this.selectedProduct[i].salesub_qty;
            this.selectedProduct[i].sale_total_amount = this.selectedProduct[i].salesub_rate * this.selectedProduct[i].salesub_qty + this.selectedProduct[i].salesub_tax_amnt - this.selectedProduct[i].item_disc;
            this.selectedProduct[i].salesub_amnt = this.selectedProduct[i].salesub_rate * this.selectedProduct[i].salesub_qty;

          } else {
            console.log("exc vat type2");
            tax = (this.selectedProduct[i].salesub_price - (this.selectedProduct[i].item_disc)) - (((this.selectedProduct[i].salesub_price - (this.selectedProduct[i].item_disc)) * 100) / (this.selectedProduct[i].salesub_tax_per + 100));

            this.selectedProduct[i].salesub_tax = tax / this.selectedProduct[i].salesub_qty;
            this.selectedProduct[i].salesub_tax_amnt = tax;
            this.selectedProduct[i].salesub_rate = (this.selectedProduct[i].salesub_price - tax) / this.selectedProduct[i].salesub_qty;

            console.log("this.selectedProduct[i].salesub_rate");
            console.log(this.selectedProduct[i].salesub_rate);
            
            console.log("this.selectedProduct[i].salesub_price");
            console.log(this.selectedProduct[i].salesub_price);

            console.log("tax");
            console.log(tax);
            
            console.log("this.selectedProduct[i].salesub_qty");
            console.log(this.selectedProduct[i].salesub_qty);
            

            this.selectedProduct[i].sale_total_amount = this.selectedProduct[i].salesub_rate * this.selectedProduct[i].salesub_qty + this.selectedProduct[i].salesub_tax_amnt - this.selectedProduct[i].item_disc;
            // this.selectedProduct[i].salesub_rate = (this.selectedProduct[i].salesub_price - tax + Number(this.selectedProduct[i].promo_disc)) / this.selectedProduct[i].salesub_qty;
            this.selectedProduct[i].salesub_amnt = this.selectedProduct[i].salesub_rate * this.selectedProduct[i].salesub_qty;
          }
        }
      }
    });
    this.payType(this.sale_pay_type);
    this.recvdAmnt = Number(this.totItemprice + this.totVatAmnt - this.netDiscttl - Number(this.round_off)).toFixed(2);
    this.closeDiscInput();
    this.sumSaleTotal();
  }

  searchCashLedger(search: string) {
    const searchval = new FormData();
    searchval.append("ledger_name", search);
    searchval.append("ledger_grp", "3");

    this.apiService.searchLedgerByAccGroup(searchval).subscribe((res) => {
      this.cashLedgers = res["data"];
    });
  }

  searchBankLedger(search: string) {
    const searchval = new FormData();
    searchval.append("ledger_name", search);
    searchval.append("ledger_grp", "4");
    this.apiService.searchLedgerByAccGroup(searchval).subscribe((res) => {
      this.bankLedgers = res["data"];
    });
  }

  payType(value) {
    this.sale_pay_type = value;

    if (value == 1) {
      this.bank_amnt = 0;
      this.cash_amnt = (this.roundOffClick == 1) ? Number(this.sale_total_amount - this.netDiscttl + Number(this.round_off)).toFixed(2) :Number(this.sale_total_amount - this.netDiscttl - Number(this.round_off)).toFixed(2);
    } else if (value == 2) {
      this.cash_amnt = (this.roundOffClick == 1) ? Number(this.sale_total_amount - this.netDiscttl + Number(this.round_off)).toFixed(2) :Number(this.sale_total_amount - this.netDiscttl - Number(this.round_off)).toFixed(2);
      this.bank_amnt = 0;

    } else if (value == 3) {
      this.cash_amnt = 0;
      this.bank_amnt = (this.roundOffClick == 1) ? Number(this.sale_total_amount - this.netDiscttl + Number(this.round_off)).toFixed(2) :Number(this.sale_total_amount - this.netDiscttl - Number(this.round_off)).toFixed(2);
    } else if (value == 4) {
      this.cash_amnt = (this.roundOffClick == 1) ? Number(this.sale_total_amount - this.netDiscttl + Number(this.round_off)).toFixed(2) :Number(this.sale_total_amount - this.netDiscttl - Number(this.round_off)).toFixed(2);
      this.bank_amnt = 0;
    } else {
      this.cash_amnt = 0;
      this.bank_amnt = (this.roundOffClick == 1) ? Number(this.sale_total_amount - this.netDiscttl + Number(this.round_off)).toFixed(2) :Number(this.sale_total_amount - this.netDiscttl - Number(this.round_off)).toFixed(2);
    }
  }

  selectFavDetails() {
    this.isLoader = true;

    if (this.favSelect) {
      setTimeout(() => {
        const searchval = new FormData();
        searchval.append("fav_id", this.favSelect);
        this.apiService.getFavProdDetails(searchval).subscribe((res) => {
          this.productDetails = res["data"];
          this.isLoader = false;
        });
      }, 500);
    } else {
      this.searchStkPrd('');
    }
  }

  inputSelect() {
    if (!this.selectedProduct || this.selectedProduct.length == 0) {
      alert('Please select a product before holding.');
      return;
    }
    setTimeout(() => {
      this.selectInput.nativeElement.focus();
    }, 500);
  }

  selectOrderType(type: string) {
    this.selectedOrderType = type;
  }

  addHoldData() {

    if (this.holdTitle == "" || !this.holdTitle) {
      $('#holdName').css("border", "1px solid red")
    } else {
      $('#holdName').css("border", "1px solid #ccc");
      this.holdData = JSON.parse(localStorage.getItem("holdDetails")) || [];

      this.holdData.push({
        'hold_time': this.saleqt_time,
        'hold_date': this.datePipe.transform(this.saleqt_date, 'dd/MM/yyyy'),
        'hold_name': this.holdTitle,
        'net_disc': this.net_disc,
        'round_off': this.round_off,
        'includeTax' : this.includeTax,
        'hold_total': (this.roundOffClick == 1) ? this.sale_total_amount - this.netDiscttl + Number(this.round_off) : this.sale_total_amount - this.netDiscttl - Number(this.round_off),
        'prod_det': this.selectedProduct
      })


      // let temp = JSON.stringify(this.holdData);
      localStorage.setItem("holdDetails", JSON.stringify(this.holdData));
      this.holdTitle = '';
      this.coreService.showMessage('Added Successfully');
      $("#closeModal").click();
      this.resetBtn();
    }
  }

  recallData() {
    this.recalldata = JSON.parse(localStorage.getItem("holdDetails"));
  }

  reshowTable(i) {
    this.items = this.recalldata[i].prod_det;
    this.selectedProduct = [];
    
    this.includeTax = this.recalldata[i].includeTax;
    this.net_disc = this.recalldata[i].net_disc;
    this.round_off = this.recalldata[i].round_off;
    this.netDiscttl = (this.includeTax == 2) ? 0 : this.net_disc;
    
    this.items.forEach((el) => {      
      this.selectedProduct.push({
        'salesub_prd_id': el.salesub_prd_id,
        'salesub_prd': el.salesub_prd,
        'salesub_note': el.salesub_note,
        'salesub_qty': el.salesub_qty,
        'salesub_rate': el.salesub_rate,
        'salesub_tax': el.salesub_tax,
        'item_disc':el.item_disc,
        'sale_total_amount':el.sale_total_amount,
        'salesub_amnt':el.salesub_amnt,
        'salesub_price':el.salesub_price,
        'salesub_tax_amnt':el.salesub_tax_amnt,
        'salesub_tax_per':el.salesub_tax_per,
      })
    });

    this.countUpdate();
    this.sumSaleTotal();
    $("#closeRecallModal").click();
  }

  delHoldData(i) {
    this.recalldata.splice(i, 1);
    localStorage.setItem("holdDetails", JSON.stringify(this.recalldata));
  }

  clrAllData() {
    if (confirm('Are you sure you want to clear all data?')) {
      this.recalldata = [];
      localStorage.setItem("holdDetails", JSON.stringify(this.recalldata));
    }
  }

  // cashAmntchng(amnt) {
  //   this.bank_amnt = Number(this.totItemprice + this.totVatAmnt - amnt).toFixed(2);
  // }

  // bankAmntchng(amnt) {
  //   this.cash_amnt = Number(this.totItemprice + this.totVatAmnt - amnt).toFixed(2);
  // }

  // balAmntchng(amnt) {
  //   this.balAmnt = Number(this.recvdAmnt - amnt).toFixed(2);
  // }

  // unslctitem(){
  //   this.editBtns = false;
  //   this.editIndex = 0;
  // }

  vatTypeClick(type) {
    this.includeTax = type
    this.net_disc = 0;
    this.selectInput.nativeElement.focus();
  }

  roundOffTypeClick(type){
    this.roundOffClick = type;
  }

  showDiscInput() {
    if (!this.selectedProduct || this.selectedProduct.length == 0) {
      alert('Please select product before proceeding.');
      return;
    }

    this.vatTypeClick(1);
    this.showDisc = true;
    // this.round_off = 0;
    // setTimeout(() => {
    //   this.selectInput.nativeElement.focus();
    // });
  }

  closeDiscInput() {
    this.showDisc = false;
  }

  saveSale() {
    this.savedSale = [];
    this.savedSale.push({
      'cust_id': this.cust_id,
      'cust_type': this.cust_id && this.cust_id.cust_id ? "2" : "1",
      'cust_name': this.cust_id ? this.cust_id.name : this.cash_cust,
      'cntct_num': this.cust_mob,
      'vat_no': this.cust_vat,
      'cust_addr': this.cust_addres,
      'order_type': this.selectedOrderType,
      'inv_no': this.qt_no,
      'inv_type': this.sale_pay_type,
      'saleqt_date': this.datePipe.transform(this.saleqt_date, 'dd/MM/yyyy'),
      'sq_tax': this.totVatAmnt,
      'sq_total': this.totItemprice + this.totVatAmnt,
      'sale_items': this.selectedProduct,
    });

    console.log("this.cust_id");
    console.log(this.cust_id);

    console.log("this.savedSale");
    console.log(this.savedSale);


  }

  roundOff() {
    console.log("Round off section clicked");
    this.roundOffValue = true;
    this.netDiscValue = false;
    this.cashAmntValue = false;
    this.bankAmntValue = false;
    this.editBtns = false;
    this.balanceAmntValue = false;
  }

  netDiscClick() {
    console.log("Discount section clicked");
    this.netDiscValue = true;
    this.roundOffValue = false;
    this.cashAmntValue = false;
    this.bankAmntValue = false;
    this.editBtns = false;
    this.balanceAmntValue = false;
  }

  cashAmntClick() {
    console.log("cash amnt section clicked");
    this.cashAmntValue = true;
    this.bankAmntValue = false;
    this.editBtns = false;
    this.netDiscValue = false;
    this.roundOffValue = false;
    this.balanceAmntValue = false;
  }

  bankAmntClick() {
    console.log("bank amnt section clicked");
    this.bankAmntValue = true;
    this.cashAmntValue = false;
    this.editBtns = false;
    this.netDiscValue = false;
    this.roundOffValue = false;
    this.balanceAmntValue = false;
  }

  balAmntClick() {
    console.log("balance amnt section clicked");
    this.balanceAmntValue = true;
    this.bankAmntValue = false;
    this.cashAmntValue = false;
    this.editBtns = false;
    this.netDiscValue = false;
    this.roundOffValue = false;
  }

  unselect() {
    console.log("unselect clicked");
    this.roundOffValue = false;
    this.netDiscValue = false;
    this.cashAmntValue = false;
    this.bankAmntValue = false;
    this.balanceAmntValue = false;
  }

}
